import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@obg/ngx.router";

import { CompactBreadcrumbComponent } from "./compact-breadcrumb.component";

const DIRECTIVES: any[] = [CompactBreadcrumbComponent];

@NgModule({
	imports: [CommonModule, RouterModule, TranslateModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CompactBreadcrumbModule {}
